"use client";
import React from "react";
import Image from "next/image";
import AboutBanner from "../../../public/assets/background/about-banner.jpeg";
import PlantImg from "../../../public/assets/plant.png";
import Manufacture from "../../../public/assets/manufacture.jpg";
import ProductRange from "../../../public/assets/background/product-range.jpg";
import OurNetwork from "../../../public/assets/network.png";
import Qulity from "../../../public/assets/qulity.jpg";
import { GiBeerBottle, GiCampfire, GiChemicalDrop } from "react-icons/gi";
import {
  PiBeerBottle,
  PiBeerBottleLight,
  PiBuildingDuotone,
  PiCertificateDuotone,
  PiFactory,
  PiFlaskBold,
  PiGlobeDuotone,
  PiGlobeHemisphereEastDuotone,
  PiJarLabel,
} from "react-icons/pi";
import Promise from "../../../public/assets/promise.jpg";
import { GoMirror } from "react-icons/go";
import { BiLeaf, BiRadioCircleMarked, BiTestTube } from "react-icons/bi";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { TbReport, TbReportSearch } from "react-icons/tb";
import { RiUserStarLine } from "react-icons/ri";
import Link from "next/link";

const certifications = [
  {
    title: "ISO 9001 – Quality Management System",
    icon: PiCertificateDuotone,
    link: "#",
  },
  {
    title: "ISO 14001 – Environmental Management System",
    icon: PiCertificateDuotone,
    link: "#",
  },
  {
    title: "ISO 18001 – Occupational Health & Safety System",
    icon: PiCertificateDuotone,
    link: "#",
  },
  {
    title: "ISO 22000 – Product Safety & HACCP",
    icon: PiCertificateDuotone,
    link: "#",
  },
];

gsap.registerPlugin(ScrollTrigger);

const AboutUs = () => {
  return (
    <>
      <main className="xl:mt-20">
        <Image src={AboutBanner} alt="About Banner" loading="lazy" />
      </main>

      <section
        className="py-16 px-6 bg-white"
        aria-labelledby="about-emergeglass-heading"
      >
        <div className="container mx-auto max-w-6xl">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 items-center">
            <div className="md:col-span-2">
              <h2
                id="about-emergeglass-heading"
                className="mb-3 flex items-center text-2xl font-bold text-blue-900"
              >
                <GiBeerBottle
                  size={30}
                  aria-hidden="true"
                  focusable="false"
                  className="mr-2"
                />
                Emerge <span className="text-red-600 pl-1">Glass</span>
              </h2>

              <p className="mt-6 text-gray-700 text-sm md:text-base leading-relaxed max-w-xl text-justify">
                <strong>Emerge Glass, established in 2013, brings over</strong>
                <span className="text-red-600 font-semibold">
                  {" "}
                  12 years of expertise{" "}
                </span>
                in manufacturing premium glass products. Our ISO-certified
                production units are located in the mineral-rich state of
                Rajasthan, supported by our corporate head office in Connaught
                Place, New Delhi.
              </p>

              <p className="mt-6 text-gray-700 text-sm md:text-base leading-relaxed max-w-xl text-justify">
                Emerge Glass is a pioneer in India’s glass manufacturing
                industry, known for its commitment to quality, innovation, and
                cutting-edge technology across world-class infrastructure.
              </p>

              <p className="mt-4 text-gray-700 text-sm md:text-base leading-relaxed max-w-xl text-justify">
                Our parent company, <strong>Alstone</strong>, is a leading
                Indian manufacturer of aluminium and zinc cladding composite
                panels, with advanced facilities located in Uttarakhand and
                Rajasthan.
              </p>
            </div>

            {/* RIGHT IMAGE */}
            <figure className="flex justify-center md:justify-end">
              <Image
                src={PlantImg}
                alt="Emerge Glass manufacturing plant located in Rajasthan"
                className="rounded-lg w-full xl:w-auto"
                priority
              />
              <figcaption className="sr-only">
                Emerge Glass state-of-the-art industrial plant.
              </figcaption>
            </figure>
          </div>
        </div>
      </section>

      <section className="relative bg-[#282930] py-[50px] px-[20px]">
        <div className="container mx-auto relative">
          <div
            className=" bg-white rounded-xl  
                   xl:grid flex flex-col grid-cols-1 md:grid-cols-2 items-stretch shadow-2xl border border-gray-100"
          >
            <Image
              src={Manufacture}
              alt="Manufacturing"
              className="w-full h-full object-cover shadow-2xl rounded-xl"
            />
            <div className="bg-white p-4 sm:p-6 md:p-8  flex flex-col justify-center  rounded-xl">
              <h2 className="text-[#033b6f] text-xl sm:text-2xl md:text-3xl font-bold mb-4">
                Our <span className="text-[#d42427]">Manufacturing</span>{" "}
                Strength
              </h2>
              <div className="flex items-start gap-3 sm:gap-4 p-2">
                <div className="p-2 bg-red-100 rounded-full">
                  <PiFactory className="text-lg sm:text-xl md:text-2xl text-red-500" />
                </div>
                <div>
                  <h4 className="font-bold text-base sm:text-lg md:text-xl text-[#333] mb-[2px]">
                    Unit 1
                  </h4>
                  <p className="text-gray-600 text-xs sm:text-sm md:text-base leading-relaxed">
                    Per day production of 210 MT flint sheet glass and 210 MT
                    flint glass bottles
                  </p>

                  <ul className="list-disc mt-3 pl-4 flex flex-col gap-3">
                    <li>
                      <p className="text-red-500 font-semibold">
                        Sheet glass plant{" "}
                      </p>
                      <p className="text-gray-600 text-xs  md:text-sm leading-relaxed">
                        Only glass plant in India capable of producing 3
                        different thickness of sheet simultaneously with range
                        starting from 1 mm to 10 mm
                      </p>
                    </li>

                    <li>
                      <p className="text-red-500 font-semibold">
                        Flint glass bottles, jars manufacturing unit
                      </p>
                      <p className="text-gray-600 text-xs  md:text-sm leading-relaxed">
                        State of the art facility equipped with brand new Emhart
                        IS machines, capable to produce glass bottles and jars
                        ranging from 90 ml to 1000 ml capacity.
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
              <hr className="opacity-10 my-2" />
              <div className="flex items-start gap-3 sm:gap-4 p-2">
                <div className="p-2 bg-red-100 rounded-full">
                  <PiFlaskBold className="text-lg sm:text-xl md:text-2xl text-red-500" />
                </div>
                <div>
                  <h4 className="font-bold text-base sm:text-lg md:text-xl text-[#333] mb-1">
                    Unit 2
                  </h4>
                  <p className="text-gray-600 text-xs sm:text-sm md:text-base leading-relaxed">
                    Per day production of 240 MT colour glass bottles and
                    upcoming 300 MT Solar Glass sheets:
                  </p>
                  <ul className="list-disc mt-3 pl-4 flex flex-col gap-3">
                    <li>
                      <p className="text-[#033b6f] font-semibold">
                        Coloured Glass Bottles and vials manufacturing unit
                      </p>
                      <p className="text-gray-600 text-xs  md:text-sm leading-relaxed">
                        State of art facility equipped with brand new Emhart
                        manufacturing and on-line inspection machines capable of
                        producing glass bottles in NNPB process and B&B process
                        with range of 30 ml to 1000 ml capacity.
                      </p>
                    </li>

                    <li>
                      <p className="text-[#033b6f] font-semibold">
                        Solar panel glass sheets manufacturing unit
                      </p>
                      <p className="text-gray-600 text-xs  md:text-sm leading-relaxed">
                        State of art unit to cater to growing requirement of low
                        iron sheet glass, with ready to use processed sheets for
                        direct use in panel manufacturing.
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-[50px] px-[20px]">
        <div className="container mx-auto">
          <div
            className=" bg-white rounded-xl z-20 
                   xl:grid flex flex-col-reverse grid-cols-1 md:grid-cols-2 items-stretch shadow-2xl border border-gray-100"
          >
            <div className="bg-white p-4 sm:p-6 md:p-8 rounded-b-xl md:rounded-se-xl md:rounded-ee-xl flex flex-col justify-center">
              <h2 className="text-[#033b6f] text-xl sm:text-2xl md:text-3xl font-bold mb-4">
                Industries <span className="text-[#d42427]"> served </span>
              </h2>
              <ul className="space-y-4 sm:space-y-6 md:space-y-8">
                <li className="flex items-start gap-3 sm:gap-4">
                  <div className="p-2 bg-red-100 rounded-full">
                    <GoMirror className="text-lg sm:text-xl md:text-2xl text-red-500" />
                  </div>
                  <div>
                    <h4 className="font-bold text-base sm:text-lg md:text-xl text-[#333] mb-1">
                      Sheet Glass
                    </h4>
                    <ul className="list-disc mt-3 pl-4 flex flex-col gap-3">
                      <li>
                        <p className="text-[#033b6f] font-semibold">
                          Flat Glass (1mm to 10mm)
                        </p>
                        <p className="text-gray-600 text-xs  md:text-sm leading-relaxed">
                          Photo frames, micro-slides, clocks, household,
                          windows.
                        </p>
                      </li>

                      <li>
                        <p className="text-[#033b6f] font-semibold">Mirrors</p>
                        <p className="text-gray-600 text-xs  md:text-sm leading-relaxed">
                          Environment friendly, Free from copper, tin with
                          crystal-clear reflection.
                        </p>
                      </li>

                      <li>
                        <p className="text-[#033b6f] font-semibold">
                          Frosted Glass
                        </p>
                        <p className="text-gray-600 text-xs  md:text-sm leading-relaxed">
                          Plain and designer variants, widely used in modern
                          architecture to bring elegance and privacy to
                          interiors.
                        </p>
                      </li>
                    </ul>
                  </div>
                </li>
                <li>
                  <hr className="opacity-5" />
                </li>
                <li className="flex items-start gap-3 sm:gap-4">
                  <div className="p-2 bg-green-100 rounded-full">
                    <PiJarLabel  className="text-lg sm:text-xl md:text-2xl text-green-800" />
                  </div>
                  <div>
                    <h4 className="font-bold text-base sm:text-lg md:text-xl text-[#333] mb-1">
                      Flint Glass Bottles & Jars
                    </h4>
                    <ul className="list-disc mt-3 pl-4 flex flex-col gap-3">
                      <li>
                        <p className="text-[#033b6f] font-semibold">
                          Glass bottles being served to Liquor, Beverages, Food
                          processing industries
                        </p>
                      </li>

                      <li>
                        <p className="text-[#033b6f] font-semibold">
                          Glass Jars are being served to Food processers-
                          Pickle, Jams, Chutney manufacturers
                        </p>
                      </li>
                    </ul>
                  </div>
                </li>
                <li>
                  <hr className="opacity-5" />
                </li>
                <li className="flex items-start gap-3 sm:gap-4">
                  <div className="p-2 bg-red-100 rounded-full">
                    <PiBeerBottle className="text-lg sm:text-xl md:text-2xl text-red-500" />
                  </div>
                  <div>
                    <h4 className="font-bold text-base sm:text-lg md:text-xl text-[#333] mb-1">
                      Coloured Glass Bottles & Vials
                    </h4>
                   <ul className="list-disc mt-3 pl-4 flex flex-col gap-3">
                      <li>
                        <p className="text-[#033b6f] font-semibold">
                          Glass bottles being used in Beer, pharmaceutical industries
                        </p>
                      </li>

                      <li>
                        <p className="text-[#033b6f] font-semibold">
                          Glass vials being used in Pharmaceutical industry.
                        </p>
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>

            <Image
              src={ProductRange}
              alt="Product Range"
              className="w-full h-full object-cover shadow-2xl rounded-xl"
            />
          </div>
        </div>
      </section>

      <section className="relative bg-[#001324] py-[50px] px-[20px]">
        <div className="container mx-auto">
          <div
            className=" bg-white rounded-xl 
                   xl:grid flex flex-col grid-cols-1 md:grid-cols-2 items-stretch shadow-2xl border border-gray-100 "
          >
            <Image
              src={OurNetwork}
              alt="Global Presence"
              className="w-full h-full object-cover shadow-2xl rounded-xl"
            />
            <div className="bg-white p-4 sm:p-6 md:p-8 rounded-b-xl md:rounded-se-xl md:rounded-ee-xl flex flex-col justify-center">
              <h2 className="text-[#033b6f] text-xl sm:text-2xl md:text-3xl font-bold mb-3">
                Our <span className="text-[#d42427]">Network</span>
              </h2>
              <p className="text-gray-600 text-xs sm:text-sm md:text-base leading-relaxed">
                With a strong distribution footprint, Emerge Glass has built:
              </p>
              <ul className="space-y-4 sm:space-y-6 md:space-y-8 mt-6 sm:mt-8">
                <li className="flex items-center gap-3 sm:gap-4">
                  <div className="p-2 bg-red-100 rounded-full">
                    <PiGlobeDuotone className="text-lg sm:text-xl md:text-2xl text-red-500" />
                  </div>
                  <h4 className="font-bold text-base sm:text-lg md:text-xl text-[#333]">
                    250+ dealers/distributors{" "}
                    <span className="font-normal">across India</span> .
                  </h4>
                </li>
                <li>
                  <hr className="opacity-5" />
                </li>
                <li className="flex items-center gap-3 sm:gap-4">
                  <div className="p-2 bg-red-100 rounded-full">
                    <PiBuildingDuotone className="text-lg sm:text-xl md:text-2xl text-red-500" />
                  </div>

                  <h4 className="font-bold text-base sm:text-lg md:text-xl text-[#333]">
                    15 sales offices{" "}
                    <span className="font-normal">nationwide</span> .
                  </h4>
                </li>
                <li>
                  <hr className="opacity-5" />
                </li>
                <li className="flex items-start gap-3 sm:gap-4">
                  <div className="p-2 bg-red-100 rounded-full">
                    <PiGlobeHemisphereEastDuotone className="text-lg sm:text-xl md:text-2xl text-red-500" />
                  </div>
                  <h4 className="font-normal text-base sm:text-lg md:text-xl text-[#333]">
                    A growing international presence with exports to{" "}
                    <span className=" font-bold">
                      Dubai, Sri Lanka, Brazil, the Netherlands, Nepal,
                      Bangladesh, and Turkey, Africa
                    </span>{" "}
                    .
                  </h4>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="py-[50px] px-[20px] bg-white ">
        <div className="container mx-auto">
          <div
            className=" bg-white rounded-xl z-20 
                   xl:grid flex flex-col-reverse grid-cols-1 md:grid-cols-2 items-stretch shadow-2xl border border-gray-100"
          >
            <div className="bg-white p-4 sm:p-6 md:p-8 rounded-b-xl md:rounded-se-xl md:rounded-ee-xl flex flex-col justify-center">
              <h2 className="text-[#033b6f] text-xl sm:text-2xl md:text-3xl font-bold mb-4">
                What <span className="text-[#d42427]">Makes Us</span> Unique
              </h2>
              <p className="text-gray-600 text-xs sm:text-sm md:text-base leading-relaxed">
                At Emerge Glass,{" "}
                <strong>quality is not a process; it’s a culture</strong>. We
                ensure product excellence through:
              </p>
              <ul className="space-y-4 sm:space-y-6 md:space-y-8 mt-6 sm:mt-8">
                <li className="flex items-center gap-3 sm:gap-4">
                  <div className="p-2 bg-red-100 rounded-full">
                    <TbReport className="text-lg sm:text-xl md:text-2xl text-red-500" />
                  </div>
                  <h4 className="font-bold text-base sm:text-lg md:text-xl text-[#333]">
                    Standard operating procedures and company-wide policies.
                  </h4>
                </li>
                <li>
                  <hr className="opacity-5" />
                </li>
                <li className="flex items-center gap-3 sm:gap-4">
                  <div className="p-2 bg-red-100 rounded-full">
                    <TbReportSearch className="text-lg sm:text-xl md:text-2xl text-red-500" />
                  </div>
                  <h4 className="font-bold text-base sm:text-lg md:text-xl text-[#333]">
                    Continuous monitoring and planned audits.
                  </h4>
                </li>
                <li>
                  <hr className="opacity-5" />
                </li>
                <li className="flex items-center gap-3 sm:gap-4">
                  <div className="p-2 bg-red-100 rounded-full">
                    <RiUserStarLine className="text-lg sm:text-xl md:text-2xl text-red-500" />
                  </div>
                  <h4 className="font-bold text-base sm:text-lg md:text-xl text-[#333]">
                    Regular management reviews and customer satisfaction
                    surveys.
                  </h4>
                </li>
              </ul>
            </div>

            <Image
              src={PlantImg}
              alt="Sustainability"
              className="w-full h-full object-cover shadow-2xl rounded-xl"
            />
          </div>
        </div>
      </section>

      <section className="py-[80px]  bg-gradient-to-br from-gray-50 via-gray-100 to-gray-200  px-[20px]">
        <div className="container mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 items-center lg:gap-6">
            <Image
              src={Qulity}
              alt="factory image"
              loading="lazy"
              className=" rounded-lg relative z-10 w-full h-auto "
            />
            <div className="xl:pl-10 ">
              <h2 className="text-[#033b6f] text-2xl md:text-3xl font-bold mb-3">
                Quality <span className="text-[#d42427]">& </span>{" "}
                Certifications
              </h2>
              <p className="mb-1 text-gray-600 text-xs sm:text-sm md:text-base leading-relaxed">
                Our advanced <strong>QA systems</strong> are in place from day
                one of operations. Our units are equipped with globally
                recognized certifications:
              </p>

              <ul className="flex flex-col gap-4 text-sm md:text-base text-gray-700 leading-relaxed mt-5">
                {certifications.map((item, index) => (
                  <li key={index}>
                    <Link
                      href={item.link}
                      className={`flex items-center bg-white gap-4 p-2 shadow-2xl border rounded-lg border-gray-200 
                    relative before:absolute before:h-full before:right-0 before:top-0 
                    before:bg-gradient-to-l before:from-red-100 before:to-transparent 
                    before:rounded-lg before:transition-all before:duration-500
                    hover:before:w-full hover:before:duration-700
                    ${index === 0 ? "before:w-full" : "before:w-0"}`}
                    >
                      <div className="p-2 bg-red-100 rounded-full">
                        <item.icon className="text-xl md:text-2xl text-red-500" />
                      </div>
                      <h4 className="font-bold text-base md:text-lg text-[#003049] relative">
                        {item.title}
                      </h4>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <h4 className="font-bold text-base md:text-2xl mt-5 xl:mt-0 text-[#003049] relative col-span-2">
              We also operate
            </h4>

            <ul className="col-span-2 grid md:grid-cols-2 grid-cols-1 gap-4 text-sm md:text-base text-gray-700 leading-relaxed ">
              <li className="flex items-center gap-3 sm:gap-4 bg-white p-2 shadow-2xl border rounded-lg border-gray-200  relative  ">
                <div className="p-2 bg-red-100 rounded-full">
                  <BiTestTube className="text-lg sm:text-xl md:text-2xl text-red-500" />
                </div>

                <h4 className="font-bold text-base sm:text-lg md:text-lg text-[#333]">
                  Advanced QA Lab{" "}
                  <span className="font-normal">
                    to ensure dimensional and performance consistency.
                  </span>{" "}
                  .
                </h4>
              </li>

              <li className="flex items-center gap-3 sm:gap-4 bg-white p-2 shadow-2xl border rounded-lg border-gray-200  relative">
                <div className="p-2 bg-red-100 rounded-full">
                  <GiChemicalDrop className="text-lg sm:text-xl md:text-2xl text-red-500" />
                </div>

                <h4 className="font-bold text-base sm:text-lg md:text-lg text-[#333]">
                  Chemical Lab{" "}
                  <span className="font-normal">
                    for raw material testing, batch control, and maintaining
                    glass composition standards.
                  </span>
                </h4>
              </li>
            </ul>
          </div>
        </div>
      </section>

      <section className="relative  py-16 px-4 sm:px-6 md:px-8 overflow-hidden">
        <div className="absolute top-0 right-0 w-40 sm:w-52 md:w-64 h-40 sm:h-52 md:h-64 bg-[#d42427]/10 rounded-full blur-3xl -z-10"></div>
        <div className="absolute bottom-0 left-0 w-48 sm:w-60 md:w-72 h-48 sm:h-60 md:h-72 bg-[#033b6f]/10 rounded-full blur-3xl -z-10"></div>

        <div className="container mx-auto">
          <h2 className="text-[#033b6f] text-2xl sm:text-3xl md:text-4xl font-bold mb-8 text-center">
            Emerge Glass <span className="text-[#d42427]">– A Part of </span>{" "}
            Alstone Group
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 md:gap-10">
            <div className="bg-white/80 backdrop-blur-md shadow-lg rounded-2xl p-6 sm:p-8 hover:shadow-2xl transition text-center md:text-left">
              <p className="text-gray-600 text-xs sm:text-sm md:text-base leading-relaxed mb-4 sm:mb-6">
                Emerge Glass proudly operates under the umbrella of
                <span className="text-[#d42427] font-semibold">
                  {" "}
                  Alstone Group
                </span>
                , a market leader in{" "}
                <strong>innovative building and cladding solutions.</strong>
              </p>

              <p className="text-gray-600 text-xs sm:text-sm md:text-base leading-relaxed">
                By being a part of the Alstone family, Emerge Glass benefits
                from the group’s{" "}
                <strong>
                  visionary leadership, nationwide presence, and culture of
                  excellence
                </strong>
                , enabling us to scale faster and deliver world-class glass
                solutions to global markets.
              </p>
            </div>

            {/* Right Card */}
            <div className="bg-white/80 backdrop-blur-md shadow-lg rounded-2xl p-6 sm:p-8 hover:shadow-2xl transition text-center md:text-left">
              <p className="text-gray-600 text-xs sm:text-sm md:text-base leading-relaxed mb-4 sm:mb-6">
                With a strong legacy of{" "}
                <strong>trust, innovation, and quality</strong>, Alstone has
                established itself as one of India’s most respected brands in
                the construction and design industry. The group’s diverse
                portfolio includes:
              </p>

              <ul className="space-y-3 text-gray-800 text-base sm:text-lg">
                {[
                  "Metal Composite Panels (MCPs)",
                  "Louvers",
                  "Aluminum Honeycomb Panels",
                  "Anometa (Anodized ACP)",
                  "Other pioneering architectural cladding solutions",
                ].map((item, i) => (
                  <li
                    key={i}
                    className="flex items-center gap-2 sm:gap-3 text-left justify-start text-xs sm:text-sm md:text-base"
                  >
                    <BiRadioCircleMarked className="text-red-600" />
                    <span className="flex flex-1">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="relative bg-gradient-to-b from-white via-gray-50 to-gray-100 py-16 sm:py-20 px-4 sm:px-6 md:px-0 overflow-hidden">
        <div className="absolute bottom-0 left-0 w-full h-full">
          <div className="absolute inset-0 bg-black/75"></div>
          <Image
            src={Promise}
            alt="Glass Bottles"
            className="w-full h-full object-cover object-top"
          />
        </div>

        <div className="container mx-auto relative z-10 text-center max-w-xl sm:max-w-2xl md:max-w-3xl px-2 sm:px-4">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-white mb-6 relative inline-block">
            Our <span className="text-red-400">Promise</span>
          </h2>

          <p className="text-base sm:text-lg md:text-xl leading-relaxed text-white font-medium">
            At Emerge Glass, we don’t just produce glass—we deliver{" "}
            <span className="text-blue-400 font-semibold">
              clarity, strength, sustainability to every customer with
              professional approach
            </span>{" "}
            that empower our user industries and inspire modern and healthy
            living. With innovation at our core, we are committed to creating
            glass solutions that{" "}
            <span className="text-blue-400 font-semibold">
              reflect excellence and build trust.
            </span>
          </p>
        </div>
      </section>

      <section className="py-[50px]"></section>
    </>
  );
};

export default AboutUs;
